// extracted by mini-css-extract-plugin
module.exports = {"BenefitsList":"BenefitsList_BenefitsList__l9JIy","BenefitsItem":"BenefitsList_BenefitsItem__0fPne","Title":"BenefitsList_Title__tdE53","Subtitle":"BenefitsList_Subtitle__H9Wl9"};